import { defineStore } from "pinia";

const CART_STORAGE_KEY = "mizabook_cart";

function normalizeProduct(product) {
  return {
    id: product.id,
    name: product.name,
    image: product.image,
    price: Number(product.price) || 0,
  };
}

export const useCartModule = defineStore("cartModule", {
  state: () => ({
    items: JSON.parse(localStorage.getItem(CART_STORAGE_KEY) || "[]"),
  }),

  getters: {
    itemsCount: (state) =>
      state.items.reduce(
        (total, item) => total + Number(item.quantity || 0),
        0
      ),
    subtotal: (state) =>
      state.items.reduce(
        (total, item) =>
          total + Number(item.price || 0) * Number(item.quantity || 1),
        0
      ),
  },

  actions: {
    saveCart() {
      localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(this.items));
    },

    addToCart(product, quantity = 1) {
      const normalizedProduct = normalizeProduct(product);
      const qty = Math.max(1, Number(quantity) || 1);
      const existingItem = this.items.find(
        (item) => item.id === normalizedProduct.id
      );

      if (existingItem) {
        existingItem.quantity += qty;
      } else {
        this.items.push({ ...normalizedProduct, quantity: qty });
      }

      this.saveCart();
    },

    updateQuantity(productId, quantity) {
      const item = this.items.find((cartItem) => cartItem.id === productId);
      if (!item) return;

      item.quantity = Math.max(1, Number(quantity) || 1);
      this.saveCart();
    },

    increase(productId) {
      const item = this.items.find((cartItem) => cartItem.id === productId);
      if (!item) return;

      item.quantity += 1;
      this.saveCart();
    },

    decrease(productId) {
      const item = this.items.find((cartItem) => cartItem.id === productId);
      if (!item) return;

      if (item.quantity <= 1) {
        this.removeFromCart(productId);
      } else {
        item.quantity -= 1;
        this.saveCart();
      }
    },

    removeFromCart(productId) {
      this.items = this.items.filter((item) => item.id !== productId);
      this.saveCart();
    },

    clearCart() {
      this.items = [];
      this.saveCart();
    },
  },
});
